<mat-chip-listbox [tabIndex]="-1" *ngIf="status" class="status-chip-list">
  <mat-chip
    class="easy-chip status-chip"
    [attr.aria-readonly]="true"
    [ngClass]="{
      accepted: status === 'ACCEPTED' || status === 'APPROVED',
      pending: status === 'IN_PROGRESS' || status === 'PENDING',
      rejected: status === 'REJECTED'
    }"
  >
    <mat-icon class="status-chip-icon">{{
      status === "ACCEPTED" || status === "APPROVED"
        ? "done"
        : status === "IN_PROGRESS" || status === "PENDING"
        ? "pending_actions"
        : "warning_amber"
    }}</mat-icon>
    <div class="status-label">
      {{ label ? label : ("STATUS." + status | translate) }}
    </div>
  </mat-chip>
</mat-chip-listbox>
